import {bodyLock} from "./module";

export function popups() {
    const _window = this._window;
    const _document = this._document;
    const isDesktop = !this.isTouch;
    const popups = _document.querySelector(".popups");
    const popupVideo = _document.getElementById("popup-video");
    const popupBio = _document.getElementById("popup-bio");
    const popupLinks = _document.querySelectorAll(".popup-link");
    const autoshowPopup = _document.querySelector(".popup.autoshow");
    let popupLink = "";
    let show_newsletter = "";
    let _href = "";

    if(_document.cookie.indexOf("show_newsletter") > -1) {
        show_newsletter = Object.fromEntries(document.cookie.split("; ").map(c => {
            const [key, ...v] = c.split("=");
            return [key, v.join("=")];
        })).show_newsLetter;
    } else {
        show_newsletter = true;
    };

    for(const link of popupLinks) {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            popupLink = event.target;
            _href = link.getAttribute("href").substr(1);
            if(link.classList.contains("play-video")) {
                generateVideoPopup(_href);
            } else {
                openPopup(_href);
            }
        });
    }

    _document.addEventListener("click", event => {
        const closeBtn = event.target;
        if(closeBtn.classList.contains("close-popup")) {
            if(closeBtn.parentNode.id && closeBtn.parentNode.id === "popup-newsletter") {
                document.cookie = "show_newsletter=false;path=/;";
            }
            closePopup();
        }
    });

    popups.addEventListener("click", event => {
        if(event.target.classList.contains("popups")) {
            closePopup();
        }
    });

    function openPopup(url) {
        bodyLock.lockBody();
        if(url) {
            const popup = _document.getElementById(url);
            popup.classList.add("active");
            popups.classList.add("active");
            if(url === "popup-video") {
                const closePopup = popupVideo.querySelector(".close-popup");
                setTimeout(() => {
                    closePopup.focus();
                }, 100);
            } else {
                const closePopup = popup.querySelector(".close-popup");
                if(closePopup) {
                    setTimeout(() => {
                        closePopup.focus();
                    }, 100);
                }
            }
        }
        show_newsletter = false;
    }

    function closePopup() {
        bodyLock.unlockBody();
        if(_document.querySelector(".popup.active")) {
            _document.querySelector(".popup.active").classList.remove("active");
            popups.classList.remove("active");
            if(popupVideo) {
                popupVideo.innerHTML = "";
            }
            if(popupBio) {
                popupBio.querySelector(".info").innerHTML = "";
            }
            _href= "";
            _document.removeEventListener("click", closePopup);
        }
        popupLink.focus();
    }

    function generateVideoPopup(url) {
        if(url.indexOf("vimeo") > 0) {
            popupVideo.innerHTML = `<button class="close-popup close-btn" aria-label="close popup"></button><iframe src="https://player.vimeo.com/video/${getVimeoVideoId(url)}?autoplay=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" data-no-lazy="1"></iframe>`;
            openPopup("popup-video");
        } else {
            popupVideo.innerHTML = `<button class="close-popup close-btn" aria-label="close popup"></button><iframe width="560" height="315" src="https://www.youtube.com/embed/${getYoutubeVideoId(url)}?autoplay=1" frameborder="0" data-no-lazy="1" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>`;
            openPopup("popup-video");
        }
    }

    function getYoutubeVideoId(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    function getVimeoVideoId(url) {
        var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
        var match = url.match(regExp);
        return match[5];
    }

    if(autoshowPopup) {
        _window.onload = () => {
            setTimeout(() => {
                if(autoshowPopup.id === "popup-newsletter") {
                    if(show_newsletter) {
                        openPopup("popup-newsletter");
                    }
                } else {
                    openPopup(autoshowPopup.id);
                }
            }, 10000);
        };
    }

    const leadership = document.querySelector(".leadership-list");
    if(leadership) {
        leadership.addEventListener("click", function (event) {
            const item = event.target;
            popupLink = item;
            if(item.classList.contains("bio-popup-link")) {
                const team_id = event.target.getAttribute("data-team_id");
                openPopup("popup-bio");

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: {
                        action  : "load_team_popup",
                        team_id : team_id
                    },
                    type: "POST",
                    success: function success(response) {
                        if (response) {
                            $(".popup-bio .info").html(response.content);
                            if(isDesktop) {
                                var axis = $(".custom-scrollbar").hasClass("vertical") ? "y" : "x";
                                $(".custom-scrollbar").mCustomScrollbar({
                                    axis: axis,
                                    autoExpandScrollbar: true,
                                    advanced: {autoExpandHorizontalScroll: true}
                                });
                            }
                        }
                    }
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./assets/js/modules/popups.js